import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'Utils/store'
import { multiSelectSlice } from 'Slices/multiSelectSlice'
import SliceConfig from 'Configs/fields/start_timeframe.json'
import { ContractSource } from 'Types/contractTypes'

const contractSource = ContractSource.candidates

const transformValues = function (selectedValues) {
  return selectedValues.map((value) => (value === 'None Selected' ? '' : value))
}

export const StartTimeframeSlice = multiSelectSlice(
  'start_timeframe',
  'setStartTimeframe',
  SliceConfig.values,
  SliceConfig.meta,
  transformValues
)

export const selectStartTimeframe = createSelector(
  ({ onDemandFilter: { prospectProfile } }: RootState) =>
    prospectProfile.startTimeframe.selectedValues,
  (
    selectedValues: string[]
  ): {
    selectedValues: string[]
    values: string[]
    audienceTypes: string[]
    label
  } => {
    return {
      selectedValues,
      values: SliceConfig.values,
      audienceTypes: SliceConfig.source[contractSource].audience_types,
      label: SliceConfig.meta.label,
    }
  }
)

export const { setStartTimeframe } = StartTimeframeSlice.actions

export default StartTimeframeSlice.reducer